/** Gapni to'ldirish qadami (demo `step` → gap). */
import { useState } from 'react';
import { distract, shuffle, wordRe } from '../../../data';
import type { Step } from '../engine';
import { answer, Frame, Options, Prompt } from './common';

export function GapStep({ s }: { s: Step }) {
  const w = s.w!;
  const [opts] = useState(() => shuffle([w, ...distract(w, 'w')]));
  const [picked, setPicked] = useState<number | null>(null);
  const m = w.ex.match(wordRe(w));
  const ok = picked !== null && opts[picked]!.id === w.id;
  const fill = m ? m[1]! : w.w;
  const pick = (i: number) => {
    if (picked !== null) return; setPicked(i);
    const good = opts[i]!.id === w.id;
    answer(w, good, good ? {} : { ans: <span style={{ fontSize: 18, lineHeight: '26px', fontWeight: 700 }}>{w.ex}</span> });
  };
  const blank = <span className={`blank${picked !== null ? (ok ? ' good' : ' wrong') : ''}`} id="bl">{picked !== null ? fill : '______'}</span>;
  return (
    <Frame>
      <Prompt retry={s.retry} text="Gapni toʻldiring" />
      <div className="qcard" style={{ gap: 10 }}>
        <b style={{ fontSize: 22, lineHeight: '32px' }}>
          {m && m.index !== undefined ? <>{w.ex.slice(0, m.index)}{blank}{w.ex.slice(m.index + m[0].length)}</> : w.ex}
        </b>
        <span className="t13" style={{ fontSize: 14 }}>{w.exT}</span>
      </div>
      <Options opts={opts} label={(o) => o.w} answerId={w.id} picked={picked} onPick={pick} />
    </Frame>
  );
}
